import {
  Component,
  EventEmitter,
  OnInit,
  Optional,
  Output,
  Self,
  ChangeDetectionStrategy
} from '@angular/core';
import { NgControl, Validators } from '@angular/forms';
import { AbstractValueAccessor } from 'ZalamoLibrary/src/lib/core/form/FormControl';
import { TypedFormBuilder } from 'ZalamoLibrary/src/lib/ui/form/TypedFormBuilder';
import { SoldFilesUniversalWatermarkConfigInput } from '../../../../graphql';
import cuid from 'cuid';
import { ZalamoTooltipService } from 'ZalamoLibrary/src/lib/ui/zalamo-tooltip/zalamo-tooltip.service';

@Component({
    selector: 'app-watermark-universal-config',
    templateUrl: './watermark-universal-config.component.html',
    styleUrls: ['./watermark-universal-config.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WatermarkUniversalConfigComponent
  extends AbstractValueAccessor
  implements OnInit
{
  active = 'vertical';
  model = this.fb.typedGroup<SoldFilesUniversalWatermarkConfigInput>({
    horizontal: [null, Validators.required],
    vertical: [null, Validators.required],
    soldFilesUniversalWatermarkConfigId: [cuid()],
  });
  @Output() saved = new EventEmitter<SoldFilesUniversalWatermarkConfigInput>();

  constructor(
    @Self() @Optional() public ngControl: NgControl,
    private fb: TypedFormBuilder,
    private tooltipService: ZalamoTooltipService
  ) {
    super();
    if (this.ngControl) {
    }
  }

  validate(element: HTMLElement) {
    if (this.model.controls.vertical.invalid) {
      this.tooltipService.open(
        'Brakuje ustawień dla pionowego zdjęcia',
        'above',
        element,
        { autoHideAfter: 5000 }
      );
      return false;
    }
    if (this.model.controls.horizontal.invalid) {
      this.tooltipService.open(
        'Brakuje ustawień dla poziomego zdjęcia',
        'above',
        element,
        { autoHideAfter: 5000 }
      );
      return false;
    }
    return true;
  }

  ngOnInit(): void {}
}
